import { KTSVG } from '../../../_metronic/helpers';
import { create } from 'zustand';

interface LoadingModalState {
  show: boolean
  status_text: string
  setStatusText: (status_text: string) => void
  toggleShow: (show: boolean) => void
  clear: () => void
}

export const useLoadingModalState = create<LoadingModalState>()((set) => ({
  show: false,
  status_text: 'Processing',
  setStatusText: (status_text: string) => set({status_text}),
  toggleShow: (show: boolean) => set({show}),
  clear: () => set({
    show: false,
    status_text: 'Processing',
  }),
}));


export const  LoadingModal = () => {

  const { show, status_text} = useLoadingModalState(state => state);
 
  if (! show) {
    return null;
  }

  return (
  <>
  <div
    className='modal fade show d-block'
    role='dialog'
    tabIndex={-1}
    aria-modal='true'
  >
    <div className='modal-dialog modal-dialog-centered'>
      <div className='modal-content w-auto mx-auto'>
        <div className='modal-body py-3 ps-3 pe-5'>
          <div className="d-flex flex-row align-items-center gap-3">
            <KTSVG path='/media/icons/duotune/abstract/abs013.svg' className='svg-icon-2x animation-rotate' />
            <span className="fw-bold text-muted">
              {status_text}                        
            </span>
          </div>
        </div>        
      </div>            
    </div>        
  </div>
  <div className='modal-backdrop fade show'></div>    
  </>
  )
};
